import React from 'react'
import './styles.scss'

// Used to get the logo of a club
function ClubLogo(props) {
  let src = require('../../logos/undefined.gif')

  try {
    src = require('../../logos/' + props.clubNumber + '.gif')
  } catch (e) {
    console.warn('No logo found, the placeholder has been used.')
  }

  return (
    <div className='club-logo'>
      <img src={src} />
    </div>
  )
}

export default ClubLogo
